import PropTypes from "prop-types";

const propTypes = {
  constituentID: PropTypes.number,
  updateVI: PropTypes.func
};

export default propTypes;
